import{gql as e}from"@apollo/client";const t=e`
  fragment asset on AssetType {
    alt
    assetId
    contentType
    presignedUrl
    projectId
    s3Key
    type
  }
`,n=e`
  fragment bubbleTexts on BubbleTextType {
    angle
    asset {
      ...asset
    }
    character {
      id
      image {
        ...asset
      }
      name
    }
    shape
    sort
    text
    w
    x
    y
    characterId
    id
    isTailVisible
    hasShadow
    tailType
  }
`,o=e`
  fragment contentEvent on ContentEventType {
    animation
    animationDirection
    asset {
      ...asset
    }
    backgroundColor
    borderColor
    entityId
    event
    eventDirection
    eventTitle
    id
    infinite
    millisecondDelay
    millisecondSpeed
    style
    titleColor
    triggerStyle
  }
`,s=e`
  fragment contentEventsOnPage on EventsOnPageType {
    contentEvents {
      ...contentEvent
    }
    type
  }
`,i=e`
  fragment contentPage on ContentPageType {
    actions {
      id
      conditions {
        id
        ... on QuestionConditionCheckboxSelectedType {
          selection
          answer: answers(trackingId: $userFlowStepTrackId) @include(if: $withAnswers) {
            ... on QuestionAnswerCheckboxType {
              selectedAnswers {
                questionAnswerCheckboxId
                questionResponseCheckboxId
              }
            }
          }
          contentSnippetQuestionId
          questionResponseCheckboxId
        }
        ... on QuestionConditionDateSelectedType {
          answer: answers(trackingId: $userFlowStepTrackId) @include(if: $withAnswers) {
            ... on QuestionAnswerCalendarType {
              dateAnswered
            }
          }
          contentSnippetQuestionId
          dateRangeType: type
          minDate
          maxDate
          selectedDate
          minTimeSpan
          maxTimeSpan
        }
        ... on QuestionConditionDropDownListItemSelectedType {
          answer: answers(trackingId: $userFlowStepTrackId) @include(if: $withAnswers) {
            ... on QuestionAnswerDropDownListType {
              questionResponseDropDownListId
            }
          }
          contentSnippetQuestionId
          questionResponseDropDownListId
        }
        ... on QuestionConditionNumberSelectedType {
          answer: answers(trackingId: $userFlowStepTrackId) @include(if: $withAnswers) {
            ... on QuestionAnswerNumberType {
              numberAnswered
            }
          }
          contentSnippetQuestionId
          numberSelected
        }
        ... on QuestionConditionRadioResponseSelectedType {
          selection
          answer: answers(trackingId: $userFlowStepTrackId) @include(if: $withAnswers) {
            ... on QuestionAnswerRadioType {
              questionResponseRadioId
            }
          }
          contentSnippetQuestionId
          questionResponseRadioId
          selectedRadioResponse {
            contentSnippetId
            id
            label
            questionResponseSetId
            sort
            scoreValue
            userId
            value
            __typename
          }
          __typename
        }
        ... on QuestionConditionSliderValueSelectedType {
          answer: answers(trackingId: $userFlowStepTrackId) @include(if: $withAnswers) {
            ... on QuestionAnswerSliderType {
              value
            }
          }
          contentSnippetQuestionId
          maxValue
          minValue
        }
        ... on QuestionConditionTextType {
          answer: answers(trackingId: $userFlowStepTrackId) @include(if: $withAnswers) {
            ... on QuestionAnswerMultilineTextType {
              text
            }
            ... on QuestionAnswerSinglelineTextType {
              text
            }
          }
          contentSnippetQuestionId
          text
        }
        __typename
      }
      ... on QuestionActionHideContainerType {
        containerId
        __typename
      }
      ... on QuestionActionHideSectionType {
        sectionId
        __typename
      }
      ... on QuestionActionHideSectionGroupType {
        sectionGroupId
        __typename
      }
      ... on QuestionActionHideType {
        targetSnippetId
        __typename
      }
      ... on QuestionActionShowContainerType {
        containerId
        __typename
      }
      ... on QuestionActionShowSectionType {
        sectionId
        __typename
      }
      ... on QuestionActionTriggerContentEventType {
        contentEventId
        type
        __typename
      }
      ... on QuestionActionShowSectionGroupType {
        sectionGroupId
        __typename
      }
      ... on QuestionActionShowType {
        targetSnippetId
        __typename
      }
      ... on QuestionActionHideContainerType {
        containerId
      }
      ... on QuestionActionHideSectionType {
        sectionId
      }
      ... on QuestionActionHideSectionGroupType {
        sectionGroupId
      }
      ... on QuestionActionHideType {
        targetSnippetId
      }
      ... on QuestionActionShowContainerType {
        containerId
      }
      ... on QuestionActionShowSectionType {
        sectionId
      }
      ... on QuestionActionTriggerContentEventType {
        contentEventId
        type
        __typename
      }
      ... on QuestionActionShowSectionGroupType {
        sectionGroupId
      }
      ... on QuestionActionShowType {
        targetSnippetId
      }
    }
    asset {
      ...asset
    }
    bubbleTexts {
      ...bubbleTexts
    }
    audio {
      presignedUrl
    }
    contentPageChildren(status: [PUBLISHED, UNPUBLISHED]) {
      asset {
        assetId
        presignedUrl
        contentType
        fileName
        fileSizeInBytes
        isAnimatedImage
        presignedUrl
        s3Key
        type
      }
      bubbleTexts {
        angle
        character {
          id
          image {
            presignedUrl
            contentType
            s3Key
          }
          name
          projectId
        }
        characterId
        id
        isTailVisible
        hasShadow
        shape
        tailType
        sort
        text
        w
        x
        y
      }
      audio {
        assetId
        presignedUrl
        contentType
        fileName
        fileSizeInBytes
        presignedUrl
        s3Key
        type
      }
      id
      minimumExposureTime
      sort
      url
      title
      parentId
    }
    contentEventsOnPage {
      ...contentEventsOnPage
    }
    contentGroup {
      description
      estimatedTime
      id
      tags {
        id
        name
        sort
      }
      title
      url
    }
    contentGroupId
    cssStyle {
      ...cssStyle
    }
    id
    relatedPage {
      asset {
        ...asset
      }
      id
      title
      url
    }
    sectionGroups {
      contentSections {
        contentEvent {
          ...contentEvent
        }
        contentLayoutId
        contentPageId
        cssStyle {
          ...cssStyle
        }
        id
        sectionContainers {
          contentEvent {
            ...contentEvent
          }
          cssStyle {
            ...cssStyle
          }
          id
          snippets {
            backgroundColor
            borderColor
            contentEvent {
              ...contentEvent
            }
            ...contentSnippetCluster
            ...contentSnippetApp
            ...contentSnippetAudio
            ...contentSnippetAvatar
            ...contentSnippetButton
            ...contentSnippetCode
            ...contentSnippetDocument
            ...contentSnippetEmbed
            ...contentSnippetForm
            ...contentSnippetImage
            ...contentSnippetImageMap
            ...contentSnippetMap
            ...contentSnippetQuestion
            ...contentSnippetQuote
            ...contentSnippetSlider
            ...contentSnippetSpacer
            ...contentSnippetSummary
            ...contentSnippetSummaryResult
            ...contentSnippetText
            ...contentSnippetVideo
            cssStyle {
              ...cssStyle
            }
            id
            sort
            visible
          }
          sort
          visible
        }
        sort
        visible
      }
      id
      ...sectionGroupTab
      sort
      visible
    }
    seoDescription
    seoTitle
    sort
    status
    tags {
      ...tag
    }
    title
    url
  }
`,r=e`
  fragment contentSnippetApp on ContentSnippetAppType {
    app {
      appApiKey
      appVersionId
      files {
        fileType
        id
        location {
          contentType
          presignedUrl
          s3Key
        }
      }
      id
    }
    appComponentId
  }
`,a=e`
  fragment contentSnippetAudio on ContentSnippetAudioType {
    audio: asset {
      ...asset
    }
    duration
    startAt
  }
`,p=e`
  fragment contentSnippetAvatar on ContentSnippetAvatarType {
    avatar {
      configurations: configuration {
        key
        value
      }
      imageUrl
    }
  }
`,u=e`
  fragment contentSnippetButton on ContentSnippetButtonType {
    buttonBackgroundColor
    fontColor
    foregroundColor
    hoverColor
    hyperlink
    innerText
    page {
      url
    }
    style
    target
  }
`,d=e`
  fragment contentSnippetCluster on ContentSnippetClusterResultType {
    clusterId
    resultBand(trackingId: $userFlowStepTrackId) {
      description
    }
  }
`,c=e`
  fragment contentSnippetCode on ContentSnippetCodeType {
    location {
      ...asset
    }
  }
`,l=e`
  fragment contentSnippetDocument on ContentSnippetDocumentType {
    document: asset {
      ...asset
    }
  }
`,m=e`
  fragment contentSnippetEmbed on ContentSnippetEmbedType {
    embed: code
    title
    type
  }
`,S=e`
  fragment contentSnippetForm on ContentSnippetFormType {
    form {
      contentPages {
        bubbleTexts {
          ...bubbleTexts
        }
        contentEventsOnPage {
          ...contentEventsOnPage
        }
        cssStyle {
          ...cssStyle
        }
        sectionGroups {
          contentSections {
            contentEvent {
              ...contentEvent
            }
            cssStyle {
              ...cssStyle
            }
            id
            sectionContainers {
              contentEvent {
                ...contentEvent
              }
              id
              snippets {
                contentEvent {
                  ...contentEvent
                }
                ...contentSnippetApp
                ...contentSnippetAudio
                ...contentSnippetImage
                ...contentSnippetQuestion
                ...contentSnippetSummary
                ...contentSnippetText
                ...contentSnippetVideo
                id
                sort
                visible
              }
              sort
              visible
            }
            sort
            visible
          }
          id
          ...sectionGroupTab
          sort
          visible
        }
      }
      cssStyle {
        ...cssStyle
      }
      formType
    }
    formType
    id
    sort
    visible
  }
`,I=e`
  fragment contentSnippetImage on ContentSnippetImageType {
    asset {
      ...asset
    }
    height
    width
  }
`,w=e`
  fragment contentSnippetImageMap on ContentSnippetImageMapType {
    contentGroup {
      id
      iconAsset {
        ...asset
      }
      regions {
        iconSize
        iconType
        id
        x
        y
      }
      title
    }
  }
`,g=e`
  fragment contentSnippetMap on ContentSnippetMapType {
    draggable
    grayscale
    latitude
    longitude
    zoom
  }
`,y=e`
  fragment contentSnippetQuestion on ContentSnippetQuestionType {
    answer: answers(contentPageId: $contentPageId, userFlowStepTrackId: $userFlowStepTrackId) @include(if: $withAnswers) {
      ...questionAnswersInterface
    }
    behavior
    configuration {
      id
      ... on Calendar {
        defaultDate
        maxDate
        messages {
          ...questionConfigurationMessage
        }
        minDate
      }
      ... on Checkbox {
        allowUserGeneratedResponses
        maxCheckedResponse
        messages {
          ...questionConfigurationMessage
        }
        responseSet {
          ...responseSet
        }
      }
      ... on DropDownList {
        canModify
        messages {
          ...questionConfigurationMessage
        }
        responseSet {
          ...responseSet
        }
      }
      ... on Match {
        layout
        allowUserGeneratedResponses
        matchItems {
          id
          maxItemsCount
          minItemsCount
          questionConfigurationMatchId
          sort
          text
        }
        messages {
          ...questionConfigurationMessage
        }
        randomise
        responseSet {
          ...responseSet
        }
      }
      ... on MultiResponseText {
        behavior
        maxResponse
        messages {
          ...questionConfigurationMessage
        }
        headers {
          content
          sort
          id
          hint
          width
          inputType
          alignment
        }
        minResponse
        type
      }
      ... on MultiText {
        caseSensitive
        maxLength
        messages {
          ...questionConfigurationMessage
        }
        minLength
        regex
      }
      ... on Number {
        defaultValue
        maxValue
        messages {
          ...questionConfigurationMessage
        }
        minValue
      }
      ... on Radio {
        allowUserGeneratedResponses
        canModify
        messages {
          ...questionConfigurationMessage
        }
        responseSet {
          ...responseSet
        }
      }
      ... on SingleText {
        maxLength
        messages {
          ...questionConfigurationMessage
        }
        minLength
        regex
      }
      ... on Slider {
        defaultValue
        maxValue
        messages {
          ...questionConfigurationMessage
        }
        minValue
        step
        ticks {
          label
          sliderValue
        }
      }
    }
    id
    majorNumber
    mandatory
    minorNumber
    questionText: question
    questionTextWithTooltips: questionWithTooltips
    visible
  }
`,T=e`
  fragment contentSnippetQuote on ContentSnippetQuoteType {
    author
    text
  }
`,A=e`
  fragment contentSnippetSlider on ContentSnippetSliderType {
    slider {
      animation
      arrows
      autoplay
      autoplaySpeed
      created
      description
      dots
      height
      id
      infinite
      projectId
      sliderItems {
        asset {
          ...asset
        }
        author
        id
        parentAsset {
          ...asset
        }
        quote
        text
        type
      }
      slidesToScroll
      slidesToShow
      speed
      title
      type
    }
  }
`,$=e`
  fragment contentSnippetSpacer on ContentSnippetSpacerType {
    alignment
    height
    lineBreak
    widthPercentage
  }
`,b=e`
  fragment contentSnippetSummaryResult on ContentSnippetSummaryResultType {
    additionalMessage
    answer(trackingId: $userFlowStepTrackId) @include(if: $withAnswers) {
      ...questionAnswersInterface
    }
    isCorrect(trackingId: $userFlowStepTrackId) @include(if: $withAnswers)
    question {
      questionText: question
      questionTextWithTooltips: questionWithTooltips
    }
  }
`,f=e`
  fragment contentSnippetText on ContentSnippetTextType {
    linkColor
    listIconColor
    margins {
      bottom {
        ...margin
      }
      left {
        ...margin
      }
      right {
        ...margin
      }
      top {
        ...margin
      }
    }
    text: textWithTooltips
  }
`,Q=e`
  fragment contentSnippetVideo on ContentSnippetVideoType {
    video: asset {
      ...asset
    }
    assetId
  }
`,C=e`
  fragment cssStyle on CssStyleType {
    alignItems
    backgroundColor
    borderColor
    borderRadius
    borderStyle
    class
    display
    color: fontColor
    fontSize
    icons {
      asset {
        ...asset
      }
      x
      y
    }
    id
    name
    padding
    primaryColor
    projectId
    secondaryColor
    tertiaryColor
    verticalAlign
  }
`,k=e`
  fragment margin on MarginType {
    type
    value
  }
`,R=e`
  fragment questionAnswersInterface on QuestionAnswerInterface {
    id
    contentPageId
    contentSnippetQuestionId
    ...questionAnswerCalendar
    ...questionAnswerCheckbox
    ...questionAnswerDecimal
    ...questionAnswerDropDownList
    ...questionAnswerMatch
    ...questionAnswerMultiLineText
    ...questionAnswerMultiResponseText
    ...questionAnswerRadio
    ...questionAnswerRating
    ...questionAnswerSingleLineText
    ...questionAnswerSlider
    ...questionAnswerNumber
  }
`,x=e`
  fragment questionAnswerCalendar on QuestionAnswerCalendarType {
    dateAnswered
  }
`,F=e`
  fragment questionAnswerCheckbox on QuestionAnswerCheckboxType {
    contentPageId
    contentSnippetQuestionId
    dateStamp
    feedback
    id
    isMarked
    selectedAnswers {
      ...questionAnswerCheckboxResponseCheckbox
    }
    status
    userFlowStepTrackId
  }
`,h=e`
  fragment questionAnswerCheckboxResponseCheckbox on QuestionAnswerCheckboxResponseCheckboxType {
    summaryFeedback {
      ... on SummaryFeedbackRankAndNoteType {
        id
        note
        rank
      }
      ... on SummaryFeedbackRadioType {
        id
        questionAnswerId
        questionResponseRadioId
      }
    }
    questionResponseCheckboxId
    questionResponse {
      label
    }
  }
`,q=e`
  fragment questionAnswerDropDownList on QuestionAnswerDropDownListType {
    questionResponseDropDownListId
    questionResponse {
      label
    }
  }
`,v=e`
  fragment questionAnswerMatch on QuestionAnswerMatchType {
    answers {
      definedPosition
      questionAnswerMatchId
      questionResponseMatchId
      summaryFeedback {
        ... on SummaryFeedbackMultiResponseType {
          answers {
            multiResponseCategoryId
            values
          }
        }
        ... on SummaryFeedbackRankAndNoteType {
          id
          note
          rank
        }
      }
    }
  }
`,M=e`
  fragment questionAnswerMultiLineText on QuestionAnswerMultilineTextType {
    text
  }
`,P=e`
  fragment questionAnswerMultiResponseText on QuestionAnswerMultiResponseTextType {
    responses {
      ...questionAnswerMultiResponseTextItem
    }
  }
`,D=e`
  fragment questionAnswerMultiResponseTextItem on QuestionAnswerMultiResponseTextItemType {
    id
    status
    value
    questionAnswerMultiResponseTextId
    summaryFeedback {
      ... on SummaryFeedbackMultiResponseType {
        answers {
          multiResponseCategoryId
          values
        }
      }
      ... on SummaryFeedbackRangeType {
        value
      }
    }
  }
`,U=e`
  fragment questionAnswerNumber on QuestionAnswerNumberType {
    id
    numberAnswered
  }
`,_=e`
  fragment questionAnswerDecimal on QuestionAnswerDecimalType {
    numberAnswered
  }
`,E=e`
  fragment questionAnswerRadio on QuestionAnswerRadioType {
    questionResponseRadioId
    questionResponse {
      label
    }
  }
`,L=e`
  fragment questionAnswerRating on QuestionAnswerRatingType {
    rate
  }
`,G=e`
  fragment questionAnswerSingleLineText on QuestionAnswerSinglelineTextType {
    text
  }
`,V=e`
  fragment questionAnswerSlider on QuestionAnswerSliderType {
    value
  }
`,N=e`
  fragment questionConfigurationMessage on QuestionConfigurationMessageType {
    correct
    example
    incomplete
    incorrect
  }
`,O=e`
  fragment responseSet on QuestionResponseSetType {
    availableResponses(fetchUserGeneratedResponses: true) {
      asset {
        ...asset
      }
      id
      label
      ... on QuestionResponseCheckboxType {
        scoreValue
        sort
        userId
      }
      ... on QuestionResponseDropDownListType {
        scoreValue
        sort
        userId
      }
      ... on QuestionResponseMatchType {
        correctPosition
        sort
        startPosition
        static
        userId
      }
      ... on QuestionResponseRadioType {
        scoreValue
        sort
        userId
      }
      value
    }
    id
    title
  }
`,j=e`
  fragment sectionGroupTab on SectionGroupTabType {
    ... on SectionGroupTabType {
      asset {
        ...asset
      }
      configuration {
        maxTabs
        tabsAlignment
      }
      configurationId
      tabSort
      text
      visible
    }
  }
`,B=e`
  mutation setUserAnswer(
    $contentPageId: Int
    $contentSnippetFormId: Int!
    $contentSnippetQuestionId: Int!
    $dateAnswered: DateTime
    $status: EQuestionAnswerStatus
    $userFlowStepTrackId: Int
  ) {
    questionAnswer {
      setUserAnswer(
        answerCalendar: {
          contentPageId: $contentPageId
          contentSnippetQuestionId: $contentSnippetQuestionId
          dateAnswered: $dateAnswered
          status: $status
          userFlowStepTrackId: $userFlowStepTrackId
        }
        contentSnippetFormId: $contentSnippetFormId
      ) {
        id
        contentSnippetQuestionId
        __typename
      }
    }
  }
`,z=e`
  mutation setUserAnswer(
    $contentPageId: Int
    $contentSnippetFormId: Int!
    $contentSnippetQuestionId: Int!
    $selectedAnswers: [QuestionAnswerCheckboxResponseCheckboxInputType]
    $status: EQuestionAnswerStatus
    $userFlowStepTrackId: Int
  ) {
    questionAnswer {
      setUserAnswer(
        answerCheckbox: {
          contentPageId: $contentPageId
          contentSnippetQuestionId: $contentSnippetQuestionId
          selectedAnswers: $selectedAnswers
          status: $status
          userFlowStepTrackId: $userFlowStepTrackId
        }
        contentSnippetFormId: $contentSnippetFormId
      ) {
        id
        contentSnippetQuestionId
        __typename
      }
    }
  }
`,H=e`
  mutation setUserAnswer(
    $contentPageId: Int
    $contentSnippetFormId: Int!
    $contentSnippetQuestionId: Int!
    $questionResponseDropDownListId: Int!
    $status: EQuestionAnswerStatus
    $userFlowStepTrackId: Int
  ) {
    questionAnswer {
      setUserAnswer(
        answerDropDownList: {
          contentPageId: $contentPageId
          contentSnippetQuestionId: $contentSnippetQuestionId
          questionResponseDropDownListId: $questionResponseDropDownListId
          status: $status
          userFlowStepTrackId: $userFlowStepTrackId
        }
        contentSnippetFormId: $contentSnippetFormId
      ) {
        id
        contentSnippetQuestionId
        __typename
      }
    }
  }
`,K=e`
  mutation setUserAnswer(
    $contentPageId: Int
    $contentSnippetFormId: Int!
    $contentSnippetQuestionId: Int!
    $status: EQuestionAnswerStatus
    $text: String!
    $userFlowStepTrackId: Int
  ) {
    questionAnswer {
      setUserAnswer(
        answerMultilineText: {
          contentPageId: $contentPageId
          contentSnippetQuestionId: $contentSnippetQuestionId
          status: $status
          text: $text
          userFlowStepTrackId: $userFlowStepTrackId
        }
        contentSnippetFormId: $contentSnippetFormId
      ) {
        id
        contentSnippetQuestionId
        __typename
      }
    }
  }
`,W=e`
  mutation setUserAnswer(
    $contentPageId: Int
    $contentSnippetFormId: Int!
    $contentSnippetQuestionId: Int!
    $responses: [QuestionAnswerMultiResponseTextItemInputType]
    $status: EQuestionAnswerStatus
    $userFlowStepTrackId: Int
  ) {
    questionAnswer {
      setUserAnswer(
        answerMultiResponseText: {
          contentPageId: $contentPageId
          contentSnippetQuestionId: $contentSnippetQuestionId
          responses: $responses
          status: $status
          userFlowStepTrackId: $userFlowStepTrackId
        }
        contentSnippetFormId: $contentSnippetFormId
      ) {
        id
        contentSnippetQuestionId
        __typename
        ... on QuestionAnswerMultiResponseTextType {
          responses {
            id
            status
            value
          }
        }
      }
    }
  }
`,J=e`
  mutation setUserAnswer(
    $contentPageId: Int
    $contentSnippetFormId: Int!
    $contentSnippetQuestionId: Int!
    $numberAnswered: Int!
    $status: EQuestionAnswerStatus
    $userFlowStepTrackId: Int
  ) {
    questionAnswer {
      setUserAnswer(
        answerNumber: {
          contentPageId: $contentPageId
          contentSnippetQuestionId: $contentSnippetQuestionId
          numberAnswered: $numberAnswered
          status: $status
          userFlowStepTrackId: $userFlowStepTrackId
        }
        contentSnippetFormId: $contentSnippetFormId
      ) {
        id
        contentSnippetQuestionId
        __typename
      }
    }
  }
`,X=e`
  mutation setUserAnswer(
    $contentPageId: Int
    $contentSnippetFormId: Int!
    $contentSnippetQuestionId: Int!
    $numberAnswered: Decimal!
    $status: EQuestionAnswerStatus
    $userFlowStepTrackId: Int
  ) {
    questionAnswer {
      setUserAnswer(
        answerDecimal: {
          contentPageId: $contentPageId
          contentSnippetQuestionId: $contentSnippetQuestionId
          answer: $numberAnswered
          status: $status
          userFlowStepTrackId: $userFlowStepTrackId
        }
        contentSnippetFormId: $contentSnippetFormId
      ) {
        id
        contentSnippetQuestionId
        __typename
      }
    }
  }
`,Y=e`
  mutation setUserAnswer(
    $contentPageId: Int
    $contentSnippetFormId: Int!
    $contentSnippetQuestionId: Int!
    $questionResponseRadioId: Int!
    $status: EQuestionAnswerStatus
    $userFlowStepTrackId: Int
  ) {
    questionAnswer {
      setUserAnswer(
        answerRadio: {
          contentPageId: $contentPageId
          contentSnippetQuestionId: $contentSnippetQuestionId
          questionResponseRadioId: $questionResponseRadioId
          status: $status
          userFlowStepTrackId: $userFlowStepTrackId
        }
        contentSnippetFormId: $contentSnippetFormId
      ) {
        id
        contentSnippetQuestionId
        __typename
        ... on QuestionAnswerRadioType {
          questionResponseRadioId
        }
      }
    }
  }
`,Z=e`
  mutation setUserAnswer(
    $contentPageId: Int
    $contentSnippetFormId: Int!
    $contentSnippetQuestionId: Int!
    $status: EQuestionAnswerStatus
    $text: String!
    $userFlowStepTrackId: Int
  ) {
    questionAnswer {
      setUserAnswer(
        answerSinglelineText: {
          contentPageId: $contentPageId
          contentSnippetQuestionId: $contentSnippetQuestionId
          status: $status
          text: $text
          userFlowStepTrackId: $userFlowStepTrackId
        }
        contentSnippetFormId: $contentSnippetFormId
      ) {
        contentSnippetQuestionId
        __typename
        id
      }
    }
  }
`,ee=e`
  mutation setUserAnswer(
    $contentPageId: Int
    $contentSnippetFormId: Int!
    $contentSnippetQuestionId: Int!
    $status: EQuestionAnswerStatus
    $userFlowStepTrackId: Int
    $value: Int!
  ) {
    questionAnswer {
      setUserAnswer(
        answerSlider: {
          contentPageId: $contentPageId
          contentSnippetQuestionId: $contentSnippetQuestionId
          status: $status
          userFlowStepTrackId: $userFlowStepTrackId
          value: $value
        }
        contentSnippetFormId: $contentSnippetFormId
      ) {
        id
        contentSnippetQuestionId
        __typename
      }
    }
  }
`,te=e`
  mutation setUserAnswer(
    $contentPageId: Int
    $contentSnippetFormId: Int!
    $contentSnippetQuestionId: Int!
    $status: EQuestionAnswerStatus
    $userFlowStepTrackId: Int
    $rate: Int!
  ) {
    questionAnswer {
      setUserAnswer(
        answerRating: {
          contentPageId: $contentPageId
          contentSnippetQuestionId: $contentSnippetQuestionId
          status: $status
          userFlowStepTrackId: $userFlowStepTrackId
          rate: $rate
        }
        contentSnippetFormId: $contentSnippetFormId
      ) {
        id
        contentSnippetQuestionId
        __typename
      }
    }
  }
`,ne=e`
  mutation deleteUserAnswer($answerId: Int!) {
    questionAnswer {
      deleteAnswer(answerId: $answerId)
    }
  }
`,oe=e`
  fragment summaryFeedbackConfigurationMultiResponse on SummaryFeedbackConfigurationMultiResponseType {
    categories {
      label
      sort
      id
    }
  }
`,se=e`
  fragment summaryFeedbackConfigurationRange on SummaryFeedbackConfigurationRangeType {
    contentSnippetSummaryId
    maxRange
    minRange
  }
`,ie=e`
  fragment summaryFeedbackConfigurationRadio on SummaryFeedbackConfigurationRadioType {
    contentSnippetSummaryId
    isReadOnly
    responseSet {
      availableResponses {
        label
        value
        id
      }
      id
      title
      type
    }
    responseSetId
  }
`,re=e`
  fragment summaryFeedbackConfigurationRankAndNote on SummaryFeedbackConfigurationRankAndNoteType {
    configuration
    contentSnippetSummaryId
    itemsToRank
    noteMaxLength
  }
`,ae=e`
  fragment tag on TagType {
    id
    name
    projectId
    sort
  }
`,pe=e`
  fragment contentSnippetSummary on ContentSnippetSummaryType {
    contentSnippetQuestion(fetchAnswers: true) {
      ...contentSnippetQuestion
    }
    matchItemId
    contentSnippetFormId
    summaryFeedbackConfiguration {
      label
      ...summaryFeedbackConfigurationMultiResponse
      ...summaryFeedbackConfigurationRange
      ...summaryFeedbackConfigurationRankAndNote
      ...summaryFeedbackConfigurationRadio
    }
    summaryFeedbackMode
  }
`,ue=Object.freeze({fragments:Object.freeze({asset:t,bubbleText:n,contentEvent:o,contentEventOnPage:s,contentPage:i,contentSnippet:Object.freeze({app:r,audio:a,avatar:p,button:u,cluster:d,code:c,document:l,embed:m,form:S,image:I,imageMap:w,map:g,question:y,quote:T,slider:A,spacer:$,summary:pe,summaryResult:b,text:f,video:Q}),cssStyle:C,margin:k,questionAnswer:Object.freeze({calendar:x,checkbox:F,checkboxResponseCheckbox:h,decimal:_,dropdownList:q,interface:R,match:v,multiLineText:M,multiResponseText:P,multiResponseTextItem:D,number:U,radio:E,rating:L,singleLineText:G,slider:V}),questionConfigurationMessage:N,responseSet:O,sectionGroupTab:j,summaryFeedbackConfigurationMultiResponse:oe,summaryFeedbackConfigurationRange:se,summaryFeedbackConfigurationRadio:ie,summaryFeedbackConfigurationRankAndNote:re,tag:ae}),mutations:Object.freeze({setUserAnswerCalendar:B,setUserAnswerCheckbox:z,setUserAnswerDecimal:X,setUserAnswerDropDownList:H,setUserAnswerMultiLineText:K,setUserAnswerMultiResponseText:W,setUserAnswerNumber:J,setUserAnswerRadio:Y,setUserAnswerSingleLineText:Z,setUserAnswerSlider:ee,setUserAnswerRating:te,deleteUserAnswer:ne})});export{ue as CONTENT_PAGE_CONTEXT_GRAPHQL};
//# sourceMappingURL=ContentPageContext.graphql.js.map
